import styled from 'styled-components';
import { rem } from 'polished';
import Chip from '../../base/Chip/chip';
import SectionContainer from '../SectionContainer';
import Typography from '../../base/Typography';

export const ChipPersonalizationQuizStyled = styled(Chip)`
  margin: 0 ${rem(5)} ${rem(20)};
`;

export const SectionContainerStyled = styled(SectionContainer)`
  @media print {
    display: none;
  }
`;

export const TypographyPersonalizationQuizHeadingStyled = styled(Typography)`
  && {
    padding-bottom: ${rem(10)};
  }
`;

export const TypographyPersonalizationQuizSubheadingStyled = styled(Typography)`
  && {
    padding-bottom: ${rem(35)};
  }
`;
